import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// Road IL Firebase config - used for both auth and data
const firebaseConfig = {
  apiKey: "AIzaSyCsY8yZTpfLZhW7bLiY_wc6g3eWkFLDDQ4",
  authDomain: "thetower-2d922.firebaseapp.com",
  projectId: "thetower-2d922",
  storageBucket: "thetower-2d922.firebasestorage.app",
  messagingSenderId: "159137215778",
  appId: "1:159137215778:web:e9cdfa5ef2f3411815217b"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
